import React, { useEffect, useState } from 'react';

import {
  headersMeusRelatorios,
  valoresExibidosRelatorios,
  fieldObjectRelatorios,
} from './auxiliarRelatorios';
import SubAbas from './subabas';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';
import Tabela from '../../../components/Tabela';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import { getUser } from '../../../modules/contexts/Auth/RequireAuth';
import { getRelatorios } from '../../../services/relatorios/relatoriosService';
import { ENTITY } from '../../../utils/entityNames';
import {
  ExportToExcel,
  formatDate,
  formatDateSimp,
} from '../../../utils/functions';

// Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Relatorios;

const MeusRelatorios: React.FC = () => {
  const [data, setData] = useState<any[]>([]);

  // Função para buscar dados
  useEffect(() => {
    const fetchData = async () => {
      try {
        const relatoriosData = await getRelatorios();
        setData(relatoriosData);
      } catch (error) {
        console.error('Erro ao obter relatórios:', error);
      }
    };
    fetchData();
  }, []);

  // Dados da tabela
  const tableData = data.map((item) => ({
    ID: item.id,
    'Data Gerada': formatDateSimp(item.dtRelatorioGerado),
    // Usuário: formataNomeMeioSiglas(item.usuario?.nomeCompleto || ''),
    Titulo: item.dsTitulo,
    // Template: item.dsTemplate,
    //  Visualizações: item.nVisualizacoes,
    'Última Visualização': formatDate(item.dtUltimaVisualizacao),
    // Observações: item.observacoes || '-',
    //Link: `/relatorios/${item.id}/detalhes`,
  }));

  // Dados do Offcanvas
  const offCanvasData = tableData;

  // Função para regenerar relatório
  const handleRegenerateRelatorio = (id: number) => {
    const relatorio = data.find((item) => item.id === id);
    if (relatorio) {
      alert(`Regenerando o relatório com template: ${relatorio.dsTemplate}`);
    }
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <Tabela
          headers={headersMeusRelatorios}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          rowClickable
          onRowClick={(id: number) => handleRegenerateRelatorio(id)}
          tituloCanvas="DETALHES DO RELATÓRIO GERADO"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              data,
              valoresExibidosRelatorios,
              Object.values(fieldObjectRelatorios),
              'meus_relatorios.xlsx',
              userID,
              'Meus Relatórios',
              entity,
            )
          }
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default MeusRelatorios;
